import get from 'lodash/get';
import { TProductItem, TQuantity, TVariant } from '../../../types';

export function useInventory() {
  const distructVariants = (products: Array<{ cursor:string, node:TProductItem }>) => products.reduce((acc, product) => {
    const variantsList = [];

    const titleProduct = {
      productTitle: get(product, 'node.variants.edges[0].node.product.title', ''),
      categoryFullName: get(product, 'node.variants.edges[0].node.product.category.fullName', ''),
      categoryName: get(product, 'node.variants.edges[0].node.product.category.name', ''),
      productVendor: get(product, 'node.variants.edges[0].node.product.vendor', ''),
      productType: get(product, 'node.variants.edges[0].node.product.productType', ''),
      productTags: get(product, 'node.variants.edges[0].node.product.tags', []),
      title: `Total variants: ${get(product, 'node.variants.edges', []).length}`,
      inventoryItem: {
        inventoryLevel: {
          quantities: new Array(8).fill({ quantity: null }) as Array<TQuantity>,
          location: {
            name: '',
            id: 0,
          },
        },
        id: '',
        unitCost: {
          amount: '',
          currencyCode: '',
        },
      },
      id: `${get(product, 'node.variants.edges[0].node.product.title', '')}1`, // uniq id for title
      displayName: 'Custom Variant',
      inventoryQuantity: 0,
      price: '',
      product: {
        id: '',
        title: '',
        vendor: '',
        category: {
          id: '',
          fullName: '',
          name: '',
        },
        productType: '',
        tags: [''],
      },
    } as unknown as TVariant;

    product.node.variants.edges.forEach((variant) => {
      const updatedVariant = {
        ...get(variant, 'node', {}),
        productTitle: get(variant, 'node.product.title', ''),
        categoryFullName: get(variant, 'node.product.category.fullName', ''),
        categoryName: get(variant, 'node.product.category.name', ''),
        productVendor: get(variant, 'node.product.vendor', ''),
        productType: get(variant, 'node.product.productType', ''),
        productTags: get(variant, 'node.product.tags', []),
      };

      if (get(updatedVariant, 'inventoryItem.inventoryLevel', null)) {
        variantsList.push(updatedVariant);
      }
    });

    if (variantsList.length > 0) {
      variantsList.unshift(titleProduct);

      acc.push(...variantsList);
    }
    return acc;
  }, [] as Array<TVariant>);

  const extractFilterParams = (variants: Array<TVariant>) => {
    const categories: string[] = [];
    const productTypes: string[] = [];
    const tags: string[] = [];
    const vendors: string[] = [];

    variants!.forEach((product) => {
      categories.push(get(product, 'node.product.category.name', ''));
      productTypes.push(get(product, 'node.product.productType', ''));
      tags.push(...get(product, 'node.product.tags', []));
      vendors.push(get(product, 'node.product.vendor', ''));
    });

    return {
      categories,
      productTypes,
      tags,
      vendors,
    };
  };

  return {
    distructVariants,
    extractFilterParams,
  };
}
